import {AuthenticationService} from './shared/authentication.service';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthenticatedGuard} from './shared/authenticated.guard';
import {
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSnackBarModule
} from '@angular/material';
import {CuiBackgroundModule} from '@cicero/webui/lib/core/background';
import {AccessTokenService} from './access-token/access-token.service';
import {CookieService} from './access-token/cookie.service';

@NgModule({
  imports: [
    CommonModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    MatSnackBarModule,
    CuiBackgroundModule,
    MatButtonModule,
    MatIconModule
  ],
  providers: [
    AuthenticationService,
    AuthenticatedGuard,
    AccessTokenService,
    CookieService
  ],
  declarations: [LoginComponent],
  exports: [
    LoginComponent
  ]
})
export class AuthenticationModule {
}



// WEBPACK FOOTER //
// ./src/app/authentication/authentication.module.ts